import './App.css';
import { useEffect } from 'react';
import ImprovedEnterpriseLayoutPreview from './Layout/main_layout';
import LoginInterface from './login-interface';
import { Route, Routes } from 'react-router-dom';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { GlobalErrorHandler } from './components/common/GlobalErrorHandler';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { RecsuitWorkflowPermissionAdapter } from './auth/RecsuitWorkflowPermissionAdapter';
import { bootstrapOptionsResolvers } from './components/common/DynamicForm/bootstrapOptionsResolvers';
import { bootstrapSeedResolvers } from './components/common/DynamicForm/bootstrapSeedResolvers';
import { bootstrapEmbeddedSections } from './components/modules/litigation-module/bootstrapEmbeddedSections';

function App() {
  // Register DynamicForm ref-field options resolvers + grid seed resolvers
  // once at app mount.
  useEffect(() => {
    bootstrapOptionsResolvers();
    bootstrapSeedResolvers();
    bootstrapEmbeddedSections();
  }, []);

  return (
    <AuthProvider>
      <RecsuitWorkflowPermissionAdapter>
      <GlobalErrorHandler>
        <ErrorBoundary
          showNotification={true}
          logError={true}
          errorMessage="The application encountered an error. Please try again."
        >
          <Routes>
            <Route path="/" element={<LoginInterface />} />
            <Route
              path="/Layout/main_layout"
              element={
                <ProtectedRoute>
                  <ImprovedEnterpriseLayoutPreview />
                </ProtectedRoute>
              }
            />
            {/* other routes */}
          </Routes>
        </ErrorBoundary>
      </GlobalErrorHandler>
      </RecsuitWorkflowPermissionAdapter>
    </AuthProvider>
  );
}

export default App;
